export const CONTACT_EMAIL = "support@ariesappstation.com";

export const APPS = [
  {
    id: "trailer-api",
    name: "Trailer API",
    kind: "Entertainment",
    platforms: ["iOS", "Android"],
    image: "/apps/trailer-2.jpg",
    screens: [
      { src: "/apps/trailer-2.jpg", caption: "Discover: trending now & For You" },
      { src: "/apps/trailer-3.jpg", caption: "Title details & where to watch" },
      { src: "/apps/trailer-1.jpg", caption: "Welcome & sign-in" },
    ],
    tagline: "Track every show. Never miss an episode.",
    description:
      "Trailer API helps you discover trending TV shows and movies, watch their trailers, track your progress and share what you love.",
    features: [
      "Trending Now carousel with one-tap Play Trailer",
      "Personalised For You recommendations",
      "Title pages with ratings, genres and overview",
      "Where to Watch: streaming, rent and buy options",
      "Watchlist and personal library",
      "Popular lists from other users you can follow",
      "Search across movies and TV shows",
      "Sign in with Google or email, or browse as a guest",
    ],
    tint: "from-[#1a0f08] to-[#3a1d0a]",
  },
  {
    id: "trivia-pop",
    name: "Trivia Pop",
    kind: "Games",
    platforms: ["iOS", "Android"],
    image: "/apps/trivia-1.jpg",
    screens: [
      { src: "/apps/trivia-1.jpg", caption: "Home: your journey & game modes" },
      { src: "/apps/trivia-2.jpg", caption: "A question round with power-ups" },
      { src: "/apps/trivia-3.jpg", caption: "Sign in or play as a guest" },
    ],
    tagline: "Play. Learn. Climb the ranks.",
    description:
      "Trivia Pop is a colourful quiz game with a 1,000-level journey, quick rounds across categories and power-ups that help when a question gets tough.",
    features: [
      "Daily, Quick Play and Endless game modes",
      "A 1,000-level journey map to work through",
      "Power-ups: 50/50, Retry, Vote and Skip",
      "Questions across multiple categories",
      "Ranks to see how you stack up",
      "Daily bonus coins and streaks",
      "Invite friends to earn coins and hearts",
      "Sign in with Google or Facebook, or play as a guest",
    ],
    tint: "from-[#fff3c4] to-[#fde2e2]",
  },
];

export const MARQUEE = [
  "Built for iPhone",
  "Shipped to Google Play",
  "Occasionally, the web",
  "Designed in-house",
  "Aries App Station Inc.",
];
